import axios from 'axios'
import config from '../config/dev'


const api = {

    get(params, token) {
        if (token) axios.defaults.headers.common['Authorization'] = this.getToken()
        return axios.get(`${config.ENDPOINT_BASE_URL}${params.url}`)
    },

    post(params, token) {
        if (token) axios.defaults.headers.common['Authorization'] = this.getToken()
        return axios.post(`${config.ENDPOINT_BASE_URL}${params.url}`, params.data)
    },

    postFile(params, token) {
        if (token) axios.defaults.headers.common['Authorization'] = this.getToken()
        if (token) axios.defaults.headers.common['Content-Type'] = 'multipart/form-data'
        return axios.post(`${config.ENDPOINT_BASE_URL}${params.url}`, params.data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },

    delete(params, token) {
        if (token) axios.defaults.headers.common['Authorization'] = this.getToken()
        return axios.delete(`${config.ENDPOINT_BASE_URL}${params.url}`, params.data)
    },

    put(params, token) {
        if (token) axios.defaults.headers.common['Authorization'] = this.getToken()
        return axios.put(`${config.ENDPOINT_BASE_URL}${params.url}`, params.data, {})
    },

    patch(params, token) {
        if (token) axios.defaults.headers.common['Authorization'] = this.getToken()
        return axios.patch(`${config.ENDPOINT_BASE_URL}${params.url}`, params.data)
    },

    getToken() {
        let user = JSON.parse(localStorage.getItem('user'))
        return user ? user.auth_key : null;
    },
}

export default api


// WEBPACK FOOTER //
// ./src/source/api.js